module.exports = __webpack_public_path__ + "img/mo_03.686428cb.png";